import React, { useState } from 'react';
import { TrophyIcon } from '@/components/icons/TrophyIcon';
import styles from './styles.module.scss';

export interface CountryFlagProps {
  /** Flag image URL; null (or a broken image) leaves the slot empty. */
  src: string | null;
  /** International competitions show a trophy instead of a flag. */
  international?: boolean;
}

/**
 * 28px circular country slot, decorative (the name is rendered next to it).
 * International → trophy on a tinted circle; otherwise the flag image. A
 * missing or broken flag keeps an empty slot so names stay aligned.
 */
export const CountryFlag: React.FC<CountryFlagProps> = ({ src, international = false }) => {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);

  if (international) {
    return (
      <span className={`${styles.slot} ${styles.circle} ${styles.international}`} data-flag="international">
        <TrophyIcon size={16} />
      </span>
    );
  }

  if (src && src !== failedSrc) {
    return (
      <span className={`${styles.slot} ${styles.circle}`} data-flag="image">
        <img
          className={styles.image}
          src={src}
          alt=""
          width={28}
          height={28}
          decoding="async"
          onError={() => setFailedSrc(src)}
        />
      </span>
    );
  }

  return <span className={styles.slot} data-flag="empty" aria-hidden="true" />;
};

export default CountryFlag;
